import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { useState } from "react";
import Car1 from "..//assets/svg/Car1.svg";
import Email1 from "..//assets/svg/Email1.svg";
import BatteryIcon from "../assets/svg/BatteryIcon.svg";
import BirthdayCake from "../assets/svg/BirthdayCake.svg";
import CarCareIcon from "../assets/svg/CarCareIcon.svg";
import checkIcon from "../assets/svg/CheckIcon.svg";
import DoneIcon from "../assets/svg/DoneIcon.svg";
import DropDownIcon from "../assets/svg/DropDownIcon.svg";
import Ellipse1 from "../assets/svg/Ellipse1.svg";
import FirstServicesIcons from "../assets/svg/FirstServiceIcon.svg";
import GreenDot from "../assets/svg/GreenDot.svg";
import HelpIcon from "../assets/svg/HelpIcon.svg";
import MessageIcon from "../assets/svg/MessageIcon.svg";
import PenForEdit from "../assets/svg/PenForEdit.svg";
import phoneCalling from "../assets/svg/phoneCalling.svg";
import phoneIcon from "../assets/svg/phoneIcon.svg";
import SecondServicesIcons from "../assets/svg/SecondServiceIcon.svg";
import SmallVan from "../assets/svg/SmallVan.svg";
import StateIcon from "../assets/svg/StateIcon.svg";
import ActivityLogBtns from "./ActivityLogBtns";
import ActivityPopUp from "./ActivityPopUp";

function InfoItemWithImage({ label, children }) {
  return (
    <h6
      className="d-flex justify-content-between align-items-center text-secondary"
      style={{ lineHeight: "26.24px" }}
    >
      {label}
      <span
        className="text-dark"
        style={{
          fontWeight: "600",
          lineHeight: "26.24px",
          marginLeft: "auto",
        }}
      >
        <div className="d-flex align-items-center gap-2">{children}</div>
      </span>
    </h6>
  );
}

function ImgwithData({ image, info }) {
  return (
    <div>
      <img src={image} className="me-2" />
      <span
        className="text-secondary CardItemCsspF"
        style={{
          fontWeight: "600",
          lineHeight: "26.24px",
        }}
      >
        {info}
      </span>
    </div>
  );
}
export function CardItem({ label, value }) {
  return (
    <h6
      className="d-flex justify-content-between align-items-center text-secondary"
      style={{ lineHeight: "26.24px" }}
    >
      {label}
      <span className=" text-secondary CardItemCss">{value}</span>
    </h6>
  );
}

const CustomTimelineItem = ({
  date,
  time,
  name,
  callType,
  comments,
  agentNotes,
}) => {
  return (
    <TimelineItem className="mt-3">
      <TimelineOppositeContent>
        <div>
          <h6 className="text-secondary-custom">Activity type</h6>
          <select
            className="form-select form-select-sm mb-1 mt-1"
            aria-label="Small select example"
          >
            <option selected>Open this select menu</option>
            <option value="1">
              <img src={checkIcon} className="me-1 CheckIconCss mb-1 mt-1" />
              Service Confirmed
            </option>

            <option value="2">
              <div className="d-flex">
                <img src={StateIcon} className="me-1  mb-1 mt-1 w-50" />
              </div>
              Service Postponement
            </option>
            <option value="3">
              <img src={HelpIcon} className="me-1 CheckIconCss mb-1 mt-1" />
              Help Request
            </option>
            <option value="4">
              <img src={DoneIcon} className="me-1 CheckIconCss mb-1 mt-1" />
              Service Executed
            </option>
          </select>
        </div>
        <div className="mt-3">
          <h6 className="text-secondary-custom">Call Type</h6>
          <div className="btn-group w-100">
            <button
              className="bg-transparent border rounded-2 btn-xs buttons text-dark w-100"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <div className="d-flex justify-content-between">
                <div className="justify-content-start">
                  <img
                    src={phoneIcon}
                    className="me-1 CheckIconCss mb-1 mt-1"
                  />
                  {callType}
                </div>
                <div className="justify-content-end">
                  <img src={DropDownIcon} className="me-1 CheckIconCss" />
                </div>
              </div>
            </button>
            <ul className="dropdown-menu"></ul>
          </div>
        </div>
        <div className="mt-3">
          <h6 className="text-secondary-custom">Comments</h6>
          <div className="input-group">
            <textarea
              className="form-control"
              placeholder="Please Enter Your Comment..."
              aria-label="With textarea"
              defaultValue={comments}
            ></textarea>
          </div>
        </div>
        <div className="mt-3">
          <h6 className="text-secondary-custom">Agents Notes</h6>
          <div className="input-group">
            <textarea
              className="form-control"
              placeholder="Please Enter Your Notes..."
              aria-label="With textarea"
              defaultValue={agentNotes}
            ></textarea>
          </div>
        </div>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <div className="d-flex justify-content-center">
          <span className="d-flex justify-content-start">{date}</span>
          <span className="d-flex justify-content-end mx-2">{time}</span>
        </div>
        <div className="text-center mt-2">{name}</div>
      </TimelineContent>
    </TimelineItem>
  );
};

const ActivityLog = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <ActivityPopUp show={show} handleClose={handleClose} />
      <div>
        <div className=" row justify-content-between align-items-center col-12 mt-4">
          <div className=" d-flex col-3 ms-3">
            <h3 className="fw-bold mb-0">Order #210</h3>
          </div>
          <div className=" d-flex justify-content-end col-7">
            <button
              type="button"
              className=" btn  bg-transparent border rounded-2 btn-xs buttons align-items-center"
            >
              <img src={SmallVan} />
              <span className="p-2">Assign to a van</span>
            </button>
            <button
              type="button"
              className=" btn  bg-transparent border rounded-2 btn-xs buttons ms-2  align-items-center"
            >
              <i className="fa-solid fa-location-dot"></i>
              <span className="p-2">Location on map</span>
            </button>
          </div>
        </div>
        <ActivityLogBtns />
        <div className="row">
          <div className="col-8">
            <div className="card mt-3 ms-3">
              <div className="card-header bg-transparent">
                <div className="d-flex justify-content-between mb-2">
                  <h4 className="fw-semibold align-items-center mt-2  mr-2">
                    Activity Log
                  </h4>
                  <button
                    type="button"
                    className=" flex-nowrap  align-items-center justify-content-end bg-transparent border rounded-2 btn-xs buttons mt-2 text-dark hover-black "
                    style={{ width: "116px", height: "48px" }}
                    onClick={handleShow}
                  >
                    + Add Activity
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="w-100 mt-2">
                  <Timeline sx={{ width: "100%" }} position="left">
                    <CustomTimelineItem
                      date="12 - 9 - 2024"
                      time="20:24 pm"
                      name="Ahmed Osama"
                      serviceType="Service Confirmed"
                      callType="Inbound Call"
                      comments="The service was successfully confirmed."
                      agentNotes="No additional notes."
                    />
                    <CustomTimelineItem
                      date="13 - 9 - 2024"
                      time="18:00 pm"
                      name="John Doe"
                      serviceType="Service Pending"
                      callType="Outbound Call"
                      comments="The request is pending confirmation."
                      agentNotes="Customer is awaiting response."
                    />
                  </Timeline>
                </div>
              </div>
            </div>
          </div>
          <div className="col-4 mt-3">
            <div className="card" style={{ width: "18rem" }}>
              <ul className="list-group list-group-flush">
                <li className="list-group-item ms-2 mt-3 mb-3 me-2">
                  <h5>Order #210</h5>
                  <InfoItemWithImage label="Services:">
                    <div className="d-flex">
                      <div>
                        <img
                          src={FirstServicesIcons}
                          alt="Service Icon"
                          style={{ width: "24px", height: "24px" }}
                        />
                      </div>
                      <div>
                        <img
                          src={SecondServicesIcons}
                          alt="Service Icon"
                          style={{ width: "24px", height: "24px" }}
                        />
                      </div>
                      <div>
                        <img
                          src={CarCareIcon}
                          alt="Service Icon"
                          style={{ width: "24px", height: "24px" }}
                        />
                      </div>
                      <div>
                        <img
                          src={BatteryIcon}
                          alt="Service Icon"
                          style={{ width: "24px", height: "24px" }}
                        />
                      </div>
                    </div>
                  </InfoItemWithImage>
                  <CardItem label="Order Date:" value="July 11 . 2024 " />
                </li>
                <li className="list-group-item ms-2 mt-3 mb-3 me-2">
                  <h6 className="d-flex justify-content-between">
                    Order Info
                    <div className="d-flex  justify-content-end ">
                      <img src={MessageIcon} />
                      <img src={PenForEdit} />
                    </div>
                  </h6>

                  <CardItem label="Order Date:" value="July 11 . 2024 " />
                  <CardItem label="Payment:" value="Cash" />
                  <CardItem label="Requested Date:" value="July 14 . 2024 " />
                  <CardItem label="Time:" value="09:00 am 12:00 pm" />
                  <CardItem label="Location:" value="Nasr City" />
                </li>
              </ul>
            </div>
            <div className="card mt-4" style={{ width: "18rem" }}>
              <ul className="list-group list-group-flush">
                <li className="list-group-item ms-2 mt-4 mb-3 me-2">
                  <h5>Client</h5>
                  <div className=" d-flex align-items-center ">
                    <img className="rounded mb-2 me-2" src={Ellipse1} />
                    <div>
                      <h6>Menna Ashraf</h6>
                      <div className=" ms-1">
                        <img src={BirthdayCake} className="mb-1 me-1" />
                        <span className="CardItemCsspF">12/2/1998 </span>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="list-group-item ms-2 mt-3 mb-3 me-2">
                  <h6 className="d-flex justify-content-between">
                    Client Info
                  </h6>
                  <div>
                    <ImgwithData image={phoneCalling} info=" 01003247882" />
                    <ImgwithData
                      image={Email1}
                      info=" mahitabnabil12@gmail.com"
                    />
                    <ImgwithData image={Car1} info=" 5 Vehicles" />
                    <ImgwithData
                      image={GreenDot}
                      info="Last activity : 2 July 2024  at  04:30 PM"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ActivityLog;
